import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlacklistAdministrationComponent } from './component/blacklist-administration.component';
import {  ServiceResponseModule, CommonUIButtonsModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [
    BlacklistAdministrationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    CommonTranslationModule,
    ServiceResponseModule,
    CommonUIModule,
    CommonUIButtonsModule,

    MatTableModule,
    MatFormFieldModule,
    MatInputModule
]
})
export class BlacklistAdministrationModule { }
